module.exports = __webpack_public_path__ + "img/ramp-up_c.9b95bdab.png";